import React, { useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { T } from '../theme';
import { DoneToggle } from '../components/Bits';
import Scorecards from '../components/Scorecards';
import TaskTable from '../components/TaskTable';
import CreateTaskModal from '../components/CreateTaskModal';
import TaskDetailModal from '../components/TaskDetailModal';
import MeetingsTab from '../components/MeetingsTab';
import { useLookups, useBoard } from '../usePm';

export default function BrandDetail() {
  const { accountId } = useParams();
  const nav = useNavigate();
  const aid = Number(accountId);
  const { brands, users, types } = useLookups();
  const { buckets, score, loading, showDone, setShowDone, reload, patch } = useBoard({ accountId: aid });
  const [tab, setTab] = useState('tasks');
  const [openTask, setOpenTask] = useState(null);
  const [creating, setCreating] = useState(false);
  const incompleteRef = useRef(null);
  const brand = brands.find(b => b.id === aid);

  return (
    <div>
      <button onClick={() => nav('/brands')} style={{ background: 'none', border: 'none', color: T.muted, cursor: 'pointer', fontSize: 13, marginBottom: 8 }}>← Markalar</button>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <h1 style={{ color: T.text, fontSize: 24, margin: 0 }}>{brand?.brand_name || brand?.company_name || `Marka #${aid}`}</h1>
        <button onClick={() => setCreating(true)} style={{ padding: '10px 18px', background: T.blueDark, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>+ Task Yarat</button>
      </div>

      {/* Sekmeler */}
      <div style={{ display: 'flex', gap: 4, margin: '18px 0 22px', borderBottom: `1px solid ${T.border}` }}>
        {[['tasks', 'Taskler'], ['meetings', 'Meeting Kayıtları'], ['documents', 'Documents']].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} style={{
            background: 'none', border: 'none', padding: '10px 16px', cursor: 'pointer', fontSize: 14,
            color: tab === k ? T.text : T.muted, borderBottom: tab === k ? `2px solid ${T.blue}` : '2px solid transparent', fontWeight: tab === k ? 600 : 400,
          }}>{l}</button>
        ))}
      </div>

      {tab === 'tasks' && (
        <>
          <Scorecards data={score} onIncompleteClick={() => incompleteRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })} />
          {/* Slack özetleri — scorecardların hemen altında (placeholder) */}
          <div style={{ marginBottom: 22 }}>
            <h3 style={{ color: T.text2, fontSize: 13, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>Slack Kanalı Özetleri</h3>
            <div style={{ background: T.card, border: `1px dashed ${T.border2}`, borderRadius: 10, padding: 24, color: T.dim, fontSize: 13, textAlign: 'center' }}>
              🔌 Otomasyon bağlanacak — Slack kanalı özetleri burada listelenecek.
            </div>
          </div>
          <TaskTable title="⏳ Due Date Yaklaşan (3 gün)" tasks={buckets.upcoming} loading={loading} onPatch={patch} onOpen={setOpenTask} showBrand={false} />
          <TaskTable title="🔴 Gecikmiş" tasks={buckets.overdue} loading={loading} onPatch={patch} onOpen={setOpenTask} showBrand={false} />
          <TaskTable title="🔵 Devam Ediyor · Due Date Yok" tasks={buckets.inprogress_no_due} loading={loading} onPatch={patch} onOpen={setOpenTask} showBrand={false} />
          <div ref={incompleteRef} style={{ scrollMarginTop: 16 }}>
            <TaskTable title="📋 Tamamlanmamış Görevler" titleRight={<DoneToggle checked={showDone} onChange={setShowDone} />}
              tasks={buckets.incomplete} loading={loading} onPatch={patch} onOpen={setOpenTask} showBrand={false} />
          </div>
        </>
      )}
      {tab === 'meetings' && <MeetingsTab accountId={aid} />}
      {tab === 'documents' && <Placeholder text="Documents yakında (Google Drive entegrasyonu)." />}

      {creating && <CreateTaskModal brands={brands} users={users} types={types} fixedAccountId={aid} onClose={() => setCreating(false)} onCreated={reload} />}
      {openTask && <TaskDetailModal taskId={openTask.id} brands={brands} users={users} types={types} onClose={() => setOpenTask(null)} onChanged={reload} />}
    </div>
  );
}
const Placeholder = ({ text }) => (
  <div style={{ background: T.card, border: `1px dashed ${T.border2}`, borderRadius: 10, padding: 40, color: T.dim, fontSize: 14, textAlign: 'center' }}>{text}</div>
);
